function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapache(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 236.745,
    height: 296.241,
    viewBox: "0 0 62.639 78.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M572.107 371.859c11.926-15.758 40.069 7.375 50.002 15.141 12.896 10.082 26.506 26.358 31.945 42l-20.995 17.996c3.935-3.417-27.146-27.933-30.167-30.307-10.149-7.978-44.101-26.881-30.879-44.706z",
    style: {
      fill: "#686a6d"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.503 391.555a114 114 0 0 1 7.508 7.462c-11.024 4.833-20.914 11.473-28.715 20.381a400 400 0 0 0-3.403-2.709c-1.22-.959-2.786-2.077-4.57-3.331 8.022-9.288 18.024-16.407 29.18-21.803m-17.146-13.418c3.396 2.366 6.46 4.718 8.94 6.657-11.155 5.086-20.696 13.625-28.63 23.137-2.588-1.892-5.267-3.944-7.822-6.12 7.801-9.363 16.945-17.821 27.512-23.674m-18.763-10.128c3.369 1.119 6.819 2.771 10.169 4.668-9.262 6.989-17.768 14.655-24.552 23.852-2.558-2.687-4.727-5.501-6.195-8.385 5.959-7.519 13-14.077 20.578-20.135",
    style: {
      fill: "#401f0d"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m721 437-15 50c17.731 1.098 41.416-19.79 46.797-35.777C760.799 427.449 734.133 420 721 437",
    style: {
      fill: "#686a6d"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.668 463.997c11.988-.663 32.684 12.44 16.219 21.571-12.496 6.932-29.296-2.954-40.219-8.239z",
    style: {
      fill: "#401f0d"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649 432c-9.048-7.528-22.676-14.026-33.023-5.023-8.688 7.559-8.971 23.136-3.75 32.242 9.452 16.489 30.82 23.465 46.773 28.781z",
    style: {
      fill: "#686a6d"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617 464.997c-11.988-.663-32.683 12.44-16.219 21.571 12.496 6.932 29.296-2.954 40.219-8.239z",
    style: {
      fill: "#401f0d"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684 379c-21.328.711-19.838-13.701-34.223 24.223C640 429 631.271 457.676 642 479c7.916 15.733 70.976 13.704 84 2 15.752-14.173-12-103-42-102",
    style: {
      fill: "#686a6d"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.238 385c-.029.001-27.143 1-27.143 1.003 1.054 21.005-22.518 70.708-2.639 87.566 11.121 9.431 31.49 10.485 40.427-5.18 7.87-13.795-11.829-83.33-10.645-83.389",
    style: {
      fill: "#b2b2b2"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.384 456.988c-.483-4.977-3.13-16.866-11.895-13.806-9.747 3.41-13.257 33.918-11.558 40.787 2.496 10.091 16.335 9.082 20.58 0 1.529-3.268 3.897-16.434 2.873-26.981m72.202-3.254c-2.05-4.56-8.36-14.979-15.685-9.277-8.144 6.349-1.713 36.377 2.094 42.342 5.593 8.763 18.382 3.381 19.499-6.582.402-3.586-1.564-16.818-5.908-26.483",
    style: {
      fill: "#401f0d"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.719 303.063c-24.142-26.813-66.999-35.463-99.675-19.606-24.528 11.903-54.622 36.554-45.314 68.982 9.666 33.68 47.953 33.999 74.8 36.205 29.386 2.413 92.985-.008 88.404-44.374-1.7-16.445-8.415-30.322-18.215-41.207",
    style: {
      fill: "#797a7c"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.501 256.446c2.899 1.512 5.261 4.416 6.736 9.137 3.374 10.795-1.9 41.938-16.672 42.417-11.67-5.304-36.637-10.471-29.883-27.176 4.58-11.324 27.256-30.927 39.819-24.378",
    style: {
      fill: "#797a7c"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.931 264.608c-7.61-4.84-22.939 5.985-25.766 14.424-3.013 8.991 8.942 20.779 17.967 18.92 9.731-2.004 13.42-19.535 11.555-27.402-.696-2.932-2.027-4.842-3.756-5.942",
    style: {
      fill: "#a5a5a5"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.261 256.446c-2.899 1.512-5.261 4.416-6.736 9.137-3.374 10.795 1.9 41.938 16.672 42.417 11.67-5.304 36.637-10.471 29.883-27.176-4.58-11.324-27.256-30.927-39.819-24.378",
    style: {
      fill: "#797a7c"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.831 264.608c7.61-4.84 22.938 5.985 25.766 14.424 3.013 8.991-8.942 20.779-17.967 18.92-9.73-2.004-13.42-19.535-11.555-27.402.696-2.932 2.027-4.842 3.756-5.942",
    style: {
      fill: "#a5a5a5"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659 314.254c-8.718-4.383-25.368-.035-32 5.746-7.78 6.782-12.106 21.744-4 29 17.672 15.815 57.817-23.776 36-34.746",
    style: {
      fill: "#4d525b"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 647.143,
    cy: 330,
    r: 9,
    style: {
      fill: "#401f0d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.539 328.615a2.318 2.318 0 1 1-4.637.001 2.318 2.318 0 0 1 4.637-.001",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M696.035 313.254c7.96-5.642 22.42.211 29.052 5.992 7.78 6.781 16.019 22.498 7.913 29.754-17.672 15.816-62-18-36.965-35.746",
    style: {
      fill: "#4d525b"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 706.066,
    cy: 332,
    r: 9,
    style: {
      fill: "#401f0d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.926 330.615a2.782 2.782 0 1 1-5.564.002 2.782 2.782 0 0 1 5.564-.002",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M710.557 362.055c-1.873-9.966-12.166-19.48-28.709-20.055-12.216-.425-25.347.629-33.476 10.185-7.788 9.155-6.758 20.639 4.245 27.158 16.551 9.806 63.202 10.718 57.94-17.288",
    style: {
      fill: "#b2b2b2"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.275 352.809c-2.933-9.321-25.921-10.776-26.633 1.58-.66 11.457 21.555 13.018 25.878 4.477 1.15-2.271 1.307-4.303.755-6.057",
    style: {
      fill: "#401f0d"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.536 351.114c-1.745-1.631-5.03-2.963-6.88-2.053-4.531 2.231 2.185 6.208 5.196 5.841 3.607-.439 3.333-2.247 1.684-3.788",
    style: {
      fill: "#fff"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.107 364.203c-3.67 9.084-13.599 11.29-22.31 8.904-3.738-1.023-5.322 4.765-1.596 5.786 12.21 3.343 24.771-.919 29.69-13.096 1.452-3.589-4.354-5.134-5.784-1.594",
    style: {
      fill: "#401f0d"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.543 269.948c-2.614-4.825-7.168-7.26-9.539-.812-.043-34.744-22.832 10.034-34.999 11.864 10.979-1.651 21.097 3.741 31.647 5.296 16.403 2.416 16.642-9.425 12.891-16.348",
    style: {
      fill: "#797a7c"
    },
    transform: "translate(-147.073 -60.688)scale(.26458)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapache);
export default __webpack_public_path__ + "static/media/mapache.eebaf39f22cddf4050a537f282d2c17c.svg";
export { ForwardRef as ReactComponent };